import React, { forwardRef } from 'react'
import PropTypes from 'prop-types';
import CustomScrollbars from 'react-scrollbars-custom';
import cx from 'classnames';
const Scrollbars = forwardRef(({ children, style, className, ...props }, ref) => {
    return (
        <CustomScrollbars
                noDefaultStyles
                className={cx("scrollbars", className)}
                style={{ width: '100%', ...style }}
                {...props}
                ref={ref}
            >
            {children}
        </CustomScrollbars>
    )
});
Scrollbars.propTypes = {
    style: PropTypes.object
}
Scrollbars.defaultProps = {
    style: {}
}
export default Scrollbars;
